import PropTypes from "prop-types";
export const ToggleSizes = Object.freeze({
    small: "small",
    large: "large",
});
export const ToggleSizesPropTypes = PropTypes.oneOf(Object.values(ToggleSizes));
//# sourceMappingURL=ToggleSizes.js.map